'use es6';

import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { withRouter } from 'react-router-dom';
import memoize from 'react-utils/memoize';
import UISelect from 'UIComponents/input/UISelect';
import { FileTypes } from 'FileManagerCore/Constants';
import { parseFileTypeFromLocation, parseQueryObject } from '../utils/location';
import { connect, useSelector } from 'react-redux';
import { getHasVideoIntegrationScope } from 'FileManagerCore/selectors/Auth';
import { getAreFilesUploading } from 'FileManagerCore/selectors/UploadingFiles';
import { jsx as _jsx } from "react/jsx-runtime";
const ALL_TYPES = 'ALL';
const HUBL_VIDEO = 'HUBL_VIDEO';
const NON_HUBL_VIDEO = 'NON_HUBL_VIDEO';
const VIDEO_OPTIONS = [FileTypes.MOVIE, HUBL_VIDEO, NON_HUBL_VIDEO];
const FILE_TYPE_OPTIONS = [ALL_TYPES, FileTypes.IMG, FileTypes.DOCUMENT, FileTypes.AUDIO];
const getAdvancedVideoTypeOptions = memoize(() => ({
  text: I18n.text(`FileManagerDashboard.fileTypeFilter.options.${FileTypes.MOVIE}`),
  options: VIDEO_OPTIONS.map(filterOption => {
    return {
      value: filterOption,
      text: I18n.text(`FileManagerDashboard.fileTypeFilter.options.video.${filterOption}`)
    };
  })
}));
const getSimpleFileTypeOptions = () => {
  return [...FILE_TYPE_OPTIONS, FileTypes.MOVIE].map(filterOption => ({
    value: filterOption,
    text: I18n.text(`FileManagerDashboard.fileTypeFilter.options.${filterOption}`)
  }));
};
const getFileTypeOptionsWithAdvancedVideoFilters = memoize(() => {
  return FILE_TYPE_OPTIONS.map(filterOption => ({
    value: filterOption,
    text: I18n.text(`FileManagerDashboard.fileTypeFilter.options.${filterOption}`)
  })).concat(getAdvancedVideoTypeOptions());
});
const getSelectedValueFromLocation = location => {
  const {
    isHublVideo
  } = parseQueryObject(location);
  const primitiveType = parseFileTypeFromLocation(location) || ALL_TYPES;
  if (primitiveType === FileTypes.MOVIE) {
    if (isHublVideo && isHublVideo.toLowerCase() === 'true') {
      return HUBL_VIDEO;
    } else if (isHublVideo && isHublVideo.toLowerCase() === 'false') {
      return NON_HUBL_VIDEO;
    }
  }
  return primitiveType;
};
const getQueryParamsFromSelection = filterType => {
  switch (filterType) {
    case HUBL_VIDEO:
      return [FileTypes.MOVIE, true];
    case NON_HUBL_VIDEO:
      return [FileTypes.MOVIE, false];
    default:
      return [filterType];
  }
};
const FileTypeFilter = ({
  location,
  onChange,
  hasVideoIntegrationScope
}) => {
  const areFilesUploading = useSelector(getAreFilesUploading);
  const handleChange = useCallback(e => {
    onChange(...getQueryParamsFromSelection(e.target.value === ALL_TYPES ? null : e.target.value));
  }, [onChange]);
  return /*#__PURE__*/_jsx(UISelect, {
    disabled: areFilesUploading,
    menuWidth: "auto",
    buttonUse: "transparent",
    onChange: handleChange,
    value: getSelectedValueFromLocation(location),
    options: !hasVideoIntegrationScope ? getSimpleFileTypeOptions() : getFileTypeOptionsWithAdvancedVideoFilters()
  });
};
FileTypeFilter.propTypes = {
  location: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  hasVideoIntegrationScope: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  hasVideoIntegrationScope: getHasVideoIntegrationScope(state)
});
export default withRouter(connect(mapStateToProps)( /*#__PURE__*/memo(FileTypeFilter)));